import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import api from 'api';
import { invalidateRequests, query } from 'redux-bees';
import { withRouter, Link } from 'react-router-dom';
import Log from 'components/Log';
import { notice, alert } from 'ducks/notifications';
import autobind from 'autobind-decorator';

@withRouter

@query('siteImport', api.getSiteImport, (perform, { site }) => (
  perform({ siteId: site.id })
))

export default class Import extends Component {
  static propTypes = {
    site: PropTypes.object,
    siteImport: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  }

  @autobind
  handleDestroy() {
    const { dispatch, history, site } = this.props;
    if (confirm('Are you sure?')) {
      dispatch(api.destroySite({ id: site.id }))
      .then(() => dispatch(notice('Site.destroySuccessful')))
      .then(() => dispatch(invalidateRequests(api.getSites)))
      .then(() => history.push('/'))
      .catch(() => dispatch(alert('Site.destroyFailure')));
    }
  }

  render() {
    const { siteImport, site } = this.props;

    return (
      <div>
        <div className="Import__title space--bottom-2">
          <div className="alpha">
            {
              site.attributes.wpState === 'importing' ?
                'Import is in progress...' :
                'Import completed'
            }
          </div>
          {
            site.attributes.wpState === 'importing' &&
              <button
                className="button button--tiny button--alert"
                onClick={this.handleDestroy}
              >
                Cancel import
              </button>
          }
        </div>

        <div className="space--bottom-2">
          <div className="Info">
            <div className="Info__icon">
              <i className="icon--info" />
            </div>
            {
              site.attributes.wpState === 'importing' ?
                <div className="Info__text">
                  Feel free to close this page: you will receive an email
                  notification when the process completes and our team has
                  reviewed the site and fixed any importing issues.
                  The whole review process will usually take less
                  than a working day.
                </div>
                :
                <div className="Info__text">
                  Import has been successfully completed, hurray! Our team is
                  currently reviewing your site and will manually fix any
                  noticeable problem. We will notify you via email once
                  everything is ready (the whole review process will usually take less
                  than a working day).
                </div>
            }
          </div>
        </div>

        <Log
          log={siteImport && siteImport.attributes.log}
          pending={site.attributes.wpState === 'importing'}
        >
          <Link to="/sites">
            Go back to sites
          </Link>
        </Log>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Import.jsx